export default {
    methods: {
        errorApi: function(err, callback) {
            let alertMsg = '';
            let defalutCase = true;

            if (err.id) {
                switch (err.id) {
                    case 401:
                        alertMsg = err.message;
                        break;
                    case 412:
                        alertMsg = "Token invalid";
                        defalutCase = false;
                        break;
                    default:
                        alertMsg = err.message;
                        break;
                }
            } else {
                alertMsg = "Network connection error!";
            }

            if (typeof callback == 'function' && !defalutCase) {
                callback(err);
            }

            if (this.alertModal != null) {
                this.alertModal
                    .clearModal()
                    .setMsg(alertMsg)
                    .show();
            } else if (this.modalController.alertModal != null) {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg(alertMsg)
                    .show();
            }
        },
    }
}
